/**
 * CSRF cookie that pairs with a **refresh**-token request.
 *
 * flask_jwt_extended compares the `X-CSRF-TOKEN` header against a different double-submit
 * cookie per token type: access-token requests use `csrf_access_token` (the axios
 * `xsrfCookieName` default), refresh requests use `csrf_refresh_token`. Echoing the access
 * cookie value on `POST /public/auth/refresh` is rejected with
 * `401 CSRF double submit tokens do not match`, so every refresh call must pass this name as
 * `xsrfCookieName` — setting the header by hand does not work, because axios overwrites
 * `X-CSRF-TOKEN` from `xsrfCookieName`.
 *
 * Mirrors `JWT_REFRESH_CSRF_COOKIE_NAME` in saas-control `app/config.py`.
 */
export const REFRESH_CSRF_COOKIE_NAME = 'csrf_refresh_token'
